import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12l0 .01","key":"svg-0"}],["path",{"d":"M7 12l10 0","key":"svg-1"}],["path",{"d":"M21 12l0 .01","key":"svg-2"}]]

/**
 * IconSeparator
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc2VwYXJhdG9yIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0zIDEybDAgLjAxIiAvPgogIDxwYXRoIGQ9Ik03IDEybDEwIDAiIC8+CiAgPHBhdGggZD0iTTIxIDEybDAgLjAxIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/separator
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSeparator = createReactComponent('outline', 'separator', 'Separator', __iconNode);

export default IconSeparator;